import React from 'react'
import '../styles/Skills.css'
import { SiJavascript, SiHtml5, SiCss3, SiReact, SiNodedotjs, SiFigma, SiMongodb, SiFirebase, SiTypescript, SiNextdotjs, SiBlender, SiScratch } from 'react-icons/si'
import { FaPython, FaUnity, FaJava, FaAndroid, FaReact } from 'react-icons/fa'
import { TbBrandCpp, TbBrandCSharp, TbBrandNextjs } from 'react-icons/tb'
import { DiLinux } from 'react-icons/di'

const Skills = () => {
  return (
    <div className='skills'>
      <h2>My Skills</h2>
      <div className="skill">
        <div className="python">
          <FaPython />
          <p>Python</p>
        </div>
        <div className="cpp">
          <TbBrandCpp />
          <p>C++</p>
        </div>
        <div className="unity">
          <FaUnity />
          <p>Unity</p>
        </div>
        <div className="blender">
          <SiBlender />
          <p>Blender</p>
        </div>
        <div className="html">
          <SiHtml5 />
          <p>HTML</p>
        </div>
        <div className="css">
          <SiCss3 />
          <p>CSS</p>
        </div>
        <div className="javascript">
          <SiJavascript />
          <p>JavaScript</p>
        </div>
        <div className="CSharp">
          <TbBrandCSharp />
          <p>C#</p>
        </div>
        <div className="java">
          <FaJava />
          <p>JAVA</p>
        </div>
        <div className="android">
          <FaAndroid />
          <p>Android</p>
        </div>
        <div className="Linux">
          <DiLinux />
          <p>Linux</p>
        </div>
        <div className="react">
          <FaReact />
          <p>ReactJs</p>
        </div>
        <div className="Scratch">
          <SiScratch />
          <p>Scratch</p>
        </div>
        <div className='Nextjs'>
          <TbBrandNextjs />
          <p>NextJs</p>
        </div>
      </div>
    </div>
  )
}

export default Skills;
